import React from 'react';

import './AtomLoading.global.styl';

function AtomLoading() {
  const delay = `-${Date.now() % 1800}ms`;
  const animationStyle = {
    animationDelay: delay,
  };
  return (
    <div className="mio-atom-loading">
      <div
        className="mio-atom-loading__inner mio-atom-loading__inner--one"
        style={animationStyle}
      />
      <div
        className="mio-atom-loading__inner mio-atom-loading__inner--two"
        style={animationStyle}
      />
      <div
        className="mio-atom-loading__inner mio-atom-loading__inner--three"
        style={animationStyle}
      />
    </div>
  );
}

export default AtomLoading;
